define('frontend-common-components/objectStorageConfig/js/views/layouts/addAWSStorageLayout',[
    './baseAddStorageLayout',
    'hbs!../../../templates/items/addAWSStorage',
    '../../views/items/bucketSpecifyConfigurationView',
    '../../helpers/awsHelper',
    '../../helpers/bucketSpecifyTemplateHelper',
    '../../controllers/bucketListingController',
    '../../constants/events',
    'i18n!../../../nls/objectStorageConfig',
    'underscore',
    'lodash',
    'jquery'
],
function (
    BaseAddStorageLayout,
    addStorageTmpl,
    BucketSpecifyConfigurationView,
    awsHelper,
    bucketSpecifyTemplateHelper,
    BucketListingController,
    Events,
    messageBundle,
    _,
    lodash,
    $
) {
    'use strict';
    var AddAWSStorageView = BaseAddStorageLayout.extend({
        template: addStorageTmpl,
        className: 'add-cloud-storage-view add-aws-storage-view',
        ui: {
            confirmAddStorage: '#confirm-add-storage',

            externalId: '#external-id',
            signiantAccountId: '#signiant-account-id',

            roleARNField: '#role-arn',
            roleARNWrapper: '#role-arn-wrapper',
            roleARNIcon: '#role-arn-icon',
            roleARNMessageArea: '#role-arn-message',
        },

        regions: {
            bucketConfigurationBody: '.bucket-configuration-body'
        },

        events: {
            'click @ui.confirmAddStorage': 'saveStorageConfig',
            'click @ui.bucketInConfigurationText': 'clickBucketInConfigurationText',
            'keyup @ui.roleARNField': 'handleFieldKeyUp',
            'paste @ui.roleARNField': 'handleMousePasteARN',
            'dblclick @ui.externalId': 'selectInnerText',
            'dblclick @ui.signiantAccountId': 'selectInnerText'
        },

        initialize: function (options) {

            this.initializeBucketListingController(options);
            this.initializeBucketSpecifyConfigurationView(options);

            this.listenTo(this.model, 'save:success', this.handleSaveSuccess, this);
            this.listenTo(this.model, 'save:error', this.handleSaveError, this);

            this.handleRoleARNChangeProxy = lodash.debounce(_.bind(this.handleRoleARNChange, this), 1000);
        },

        initializeBucketListingController: function (options) {
            if (options.bucketListingController) {
                this.bucketListingController = options.bucketListingController;
            } else {
                this.bucketListingController = new BucketListingController({
                    baseURL: options.baseURL
                });
            }
        },

        initializeBucketSpecifyConfigurationView: function (options) {
            if (options.bucketSpecifyConfigurationView) {
                this.bucketSpecifyConfigurationView = options.bucketSpecifyConfigurationView;
            } else{
                this.bucketSpecifyConfigurationView = new BucketSpecifyConfigurationView({
                    templateHelpers: bucketSpecifyTemplateHelper(messageBundle.storage.addPanel.aws)
                });
            }

        },

        validateFields: function () {
            this.clearErrors();
            var isValidRoleArn = this.validateRoleARN();
            var isValidDirectoryPrefix = this.bucketSpecifyConfigurationView.validateAWSBucketPrefix();
            return isValidRoleArn && isValidDirectoryPrefix;
        },
        
        validateRoleARN: function () {
            this.clearRoleARNErrors();
            var roleARN = this.ui.roleARNField.val().trim();
            if (!_.isEmpty(roleARN)) {
                if (awsHelper.isValidRoleARN(roleARN)) {
                    return true;
                } else {
                    // mark with an "empty" message
                    this.hideBucketConfigurationOptions();
                    this.markErrorField(this.ui.roleARNWrapper);
                    this.showError(this.ui.roleARNMessageArea, messageBundle.storage.notValidArn);
                    this.ui.roleARNIcon.show();
                    return false;
                }
            }
            // mark with an "empty" message
            this.hideBucketConfigurationOptions();
            this.markErrorField(this.ui.roleARNWrapper);
            this.showError(this.ui.roleARNMessageArea, messageBundle.storage.emptyArn);
            this.ui.roleARNIcon.show();
            return false;
        },

        handleFieldKeyUp: function (event) {
            var immediate = false;
            if (event.keyCode === 13) {
                immediate = true;
            }
            this.callToARNChange(immediate);
        },

        callToARNChange: function (immediate) {
            //hide the bucket options when a change is detected

            if (_.isUndefined(immediate)) {
                immediate = false;
            }
            if (!_.isEmpty(this.ui.roleARNField.val().trim()) && this.validateRoleARN()) {
                if (immediate) {
                    //If they press enter... do an immediate fetch and cancel any delayed fetches
                    this.handleRoleARNChange();
                    this.handleRoleARNChangeProxy.cancel();
                } else {
                    this.handleRoleARNChangeProxy();
                }
            } else {
                // make sure we cancel any pending bucket
                // fetches when the user has typed an invalid value in the interim
                this.handleRoleARNChangeProxy.cancel();
            }
        },

        saveStorageConfig: function (event) {
            this.ui.confirmAddStorage.prop('disabled', true);
            if (event) {
                event.preventDefault();
            }

            if (this.validateFields()) {
                this.triggerMethod(Events.configSaving);
                this.unregisterDocumentHandEventHandlers();

                this.model.set('roleARN', this.ui.roleARNField.val().trim());

                this.bucketSpecifyConfigurationView.setConfigurationValues(this.model);

                this.model.save();
            } else {
                this.ui.confirmAddStorage.prop('disabled', false);
            }
        },

        clearErrors: function () {
            this.clearRoleARNErrors();
            this.bucketSpecifyConfigurationView.clearDirectoryPrefixErrors();
        },

        clearRoleARNErrors: function () {
            this.clearErrorField(this.ui.roleARNWrapper);
            this.ui.roleARNMessageArea.text('');
            this.ui.roleARNIcon.hide();
        },

        handleSaveSuccess: function () {
            this.ui.confirmAddStorage.prop('disabled', false);
            this.triggerMethod(Events.configSaveSuccess);
            this.registerDocumentHandEventHandlers();
            this.trigger(Events.awsConfigAdded, this.model);
            this.closeAddStorageView();
        },

        handleSaveError: function (model, response) {
            this.ui.confirmAddStorage.prop('disabled', false);
            this.triggerMethod(Events.configSaveFailure, response);
            this.registerDocumentHandEventHandlers();

            if (response.status === 400) {
                this.markErrorField(this.ui.roleARNWrapper);
                this.showError(this.ui.roleARNMessageArea,
                    messageBundle.storage.addPanel.error[response.responseJSON.resultCode]);
                this.ui.roleARNIcon.show();
            }
        },

        closeAddStorageView: function () {
            this.handleRoleARNChangeProxy.cancel();
            BaseAddStorageLayout.prototype.closeAddStorageView.call(this);
        },

        onShow: function () {
            BaseAddStorageLayout.prototype.onShow.call(this);
            this.disableAddCloudStorageButton();
            this.bucketConfigurationBody.show(this.bucketSpecifyConfigurationView);
        },

        handleRoleARNChange: function () {
            this.loadBucketList();
        },

        loadBucketList: function () {
            this.triggerMethod(Events.bucketListLoading);
            this.unregisterDocumentHandEventHandlers();
            var roleARN = this.ui.roleARNField.val().trim();
            this.ui.roleARNField.blur();

            return this.bucketListingController.getAWSBucketsList(roleARN)
                .done(_.bind(function (bucketList) {
                    this.handleBucketSpecifyConfigurationsDisplay(bucketList);
                }, this))
                .fail(_.bind(function () {
                    this.handleRoleARNFailureWithMessage(messageBundle.storage.notValidArn);
                }, this))
                .always(_.bind(function () {
                    this.triggerMethod(Events.bucketListComplete)
                    this.registerDocumentHandEventHandlers();
                }, this));
        },

        handleRoleARNFailureWithMessage: function (errorMessage) {
            this.hideBucketConfigurationOptions();
            this.disableAddCloudStorageButton();
            this.showError(this.ui.roleARNMessageArea, errorMessage);
            this.ui.roleARNField.focus();
        },

        handleBucketSpecifyConfigurationsDisplay: function (bucketList) {
            this.unHideBucketConfigurationOptions(bucketList);
            this.enableAddCloudStorageButton();
        },

        hideBucketConfigurationOptions: function () {
            this.bucketSpecifyConfigurationView.hideBucketOptionsAndDisableAddCloudStorageButton();
        },

        unHideBucketConfigurationOptions: function (bucketList) {
            this.bucketSpecifyConfigurationView.show(bucketList);
        },

        disableAddCloudStorageButton: function () {
            this.ui.confirmAddStorage.attr('disabled', 'disabled');
        },

        enableAddCloudStorageButton: function () {
            this.ui.confirmAddStorage.removeAttr('disabled');
        },

        selectInnerText: function (event) {
            event.stopPropagation();
            var el = event.target;
            if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
                var range = document.createRange();
                range.selectNodeContents(el);
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof document.selection !== 'undefined' &&
                typeof document.body.createTextRange !== 'undefined') {
                var textRange = document.body.createTextRange();
                textRange.moveToElementText(el);
                textRange.select();
            }
        },

        handleMousePasteARN: function () {
            // make sure we cancel any pending bucket
            // fetches when the user has pasted something in role ARN field
            this.handleRoleARNChangeProxy.cancel();
            setTimeout(_.bind(function () {
                this.callToARNChange();
            }, this), 100);
        },

        onDestroy: function () {
            console.log('closing "add AWS storage" view. Canceling pending rest calls');
            this.handleRoleARNChangeProxy.cancel();
        }


    });

    return AddAWSStorageView;
});
